/*ěščřžýáíéúů*/
document.addEventListener("DOMContentLoaded", function () {
    const swiper = new Swiper(".swiper-gallery", {
        loop: true,
        navigation: {
            nextEl: ".swiper-button-next", // Specifičtější selektor
            prevEl: ".swiper-button-prev",
        },

        slidesPerView: "auto",
        spaceBetween: 20,
    });
});

document.addEventListener("DOMContentLoaded", function () {
    // Inicializace mapy s výchozím pohledem (bude aktualizována po geokódování)
    var map = L.map("map").setView([50.0536, 14.2923], 15); // Výchozí: Sázovická, Praha - Zličín
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    }).addTo(map);

    // Kontrola, zda je proměnná propertyLocation definována (z PHP)
    if (typeof propertyLocation !== "undefined" && propertyLocation) {
        // Použití Nominatim API pro geokódování adresy
        fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(propertyLocation)}`)
            .then((response) => response.json())
            .then((data) => {
                if (data && data.length > 0) {
                    // Získání souřadnic prvního výsledku
                    var lat = parseFloat(data[0].lat);
                    var lon = parseFloat(data[0].lon);

                    // Aktualizace pohledu mapy a přidání značky
                    map.setView([lat, lon], 15);
                    L.marker([lat, lon]).addTo(map).bindPopup(propertyLocation).openPopup();
                } else {
                    console.error("Geokódování selhalo: Adresa nenalezena.");
                    // Zachování výchozí značky a pohledu
                    L.marker([50.0536, 14.2923]).addTo(map).bindPopup("Sázovická, Praha - Zličín").openPopup();
                }
            })
            .catch((error) => {
                console.error("Chyba geokódování:", error);
                // Zachování výchozí značky a pohledu při chybě
                L.marker([50.0536, 14.2923]).addTo(map).bindPopup("Sázovická, Praha - Zličín").openPopup();
            });
    } else {
        // Záložní řešení, pokud není lokalita poskytnuta
        L.marker([50.0536, 14.2923]).addTo(map).bindPopup("Sázovická, Praha - Zličín").openPopup();
    }
});

Fancybox.bind("[data-fancybox='gallery']", {
    // Optional Fancybox settings
    loop: true,
    buttons: ["zoom", "slideShow", "thumbs", "close"],
});
